import React, { useEffect, useState } from 'react'
import './TravelFinished.min.css'

interface Thing {
  id: number;
  name: string;
  isDone: number;
}

interface Props {
  thing: Thing;
  
}

const ShoppingTravel: React.FC<Props> = ({  thing }) => {

  
  return (
    <div className='list'>
      <div className='done'>
        {thing.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true}
             readOnly
            ></input>
            <s className='text'> {thing.name} </s>
          </span>

        ) : (
          <span>
            <input type='checkbox' checked={false}
             readOnly
            ></input>
            <span className='text'> {thing.name} </span>
            
          </span>
        )
        }
        
      </div>



      



    </div>


  )
}

export default ShoppingTravel